import {departmentEn} from "./department/en";
import {UserAccountEN} from "./user-account/en";
import {NotificationEN} from "./notification/en";

export const AdminEN = {
    ...departmentEn,
    ...UserAccountEN,
    ...NotificationEN
}